const Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
    initialize: function () {
        this.view.hasServerValidationFailures = function(response) {
            let responseJson = response.responseJSON;
            return responseJson && responseJson.errors;
        };
        this.view.showServerValidationErrors = function (response) {
            let responseJson = response.responseJSON;
            let view = this;
            if (responseJson && responseJson.errors) {
                _.forEach(responseJson.errors, function (value, attr) {
                    Backbone.Validation.callbacks.invalid(view, attr, value, 'name');
                });
            }
        };
        this.view.clearValidationMessagesFor = function(attributes) {
            let view = this;
            _.forEach(attributes, function(attribute) {
                Backbone.Validation.callbacks.valid(view, attribute, 'name');
            });
        };
    }
});
